// import React from 'react';
// import Breadcrumbs from '@mui/material/Breadcrumbs';
// import NavigateNextIcon from '@mui/icons-material/NavigateNext';
// import './CustomBreadcrumbsStyle.css'
// const CustomBreadcrumbs = ({ breadcrumbs }) => {
//     return (
//         <Breadcrumbs separator={<NavigateNextIcon fontSize="small" />} aria-label="breadcrumb">
//             {breadcrumbs.map((breadcrumb, index) => (
//                 <span key={index} className={index === breadcrumbs.length - 1 ? "current-page" : "prev-page"}
//                 >{breadcrumb}</span>
//             ))}
//         </Breadcrumbs>
//     );
// };

// export default CustomBreadcrumbs;

import React, { useEffect } from 'react';
import Breadcrumbs from '@mui/material/Breadcrumbs';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import './CustomBreadcrumbsStyle.css';
import { setPageTitle } from '../../../utils/setPageTitle';

const CustomBreadcrumbs = ({ breadcrumbs }) => {

    useEffect(() => {
        const currentPage = breadcrumbs[breadcrumbs.length - 1] || "";
        setPageTitle(currentPage);
    }, [breadcrumbs]);

    return (
        <Breadcrumbs separator={<NavigateNextIcon fontSize="small" />} aria-label="breadcrumb">
            {breadcrumbs.map((breadcrumb, index) => (
                <span
                    id='current-page'
                    key={index}
                    className={index === breadcrumbs.length - 1 ? "current-page" : "prev-page"}
                >
                    {breadcrumb}
                </span>
            ))}
        </Breadcrumbs>
    );
};

export default CustomBreadcrumbs;

